"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = withAuthentication;
exports.withRedirectOnUnauthenticated = exports.withAuthState = void 0;

var _get2 = _interopRequireDefault(require("lodash/get"));

var _compose = _interopRequireDefault(require("recompose/compose"));

var _lifecycle = _interopRequireDefault(require("recompose/lifecycle"));

var _setDisplayName = _interopRequireDefault(require("recompose/setDisplayName"));

var _setPropTypes = _interopRequireDefault(require("recompose/setPropTypes"));

var _reactRedux = require("react-redux");

var _propTypes = _interopRequireDefault(require("prop-types"));

var withRedirectOnUnauthenticated = function withRedirectOnUnauthenticated() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      redirect = _ref.redirect;

  return (0, _lifecycle.default)({
    componentDidMount: function componentDidMount() {
      var isAuthenticated = (0, _get2.default)(this, 'props.auth.isAuthenticated', false);

      if (!isAuthenticated) {
        if (redirect) {
          window.location.replace("/login?redirect=".concat(encodeURIComponent(redirect)));
        } else {
          window.location.replace("/login?redirect=".concat(encodeURIComponent(window.location.href)));
        }
      }
    },
    componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
      var isAuthenticated = (0, _get2.default)(nextProps, 'auth.isAuthenticated', false);

      if (!isAuthenticated) {
        if (redirect) {
          window.location.replace("/login?redirect=".concat(encodeURIComponent(redirect)));
        } else {
          window.location.replace("/login?redirect=".concat(encodeURIComponent(window.location.href)));
        }
      }
    }
  });
};

exports.withRedirectOnUnauthenticated = withRedirectOnUnauthenticated;
var withAuthState = (0, _reactRedux.connect)(function (state) {
  return {
    auth: state.auth
  };
});
exports.withAuthState = withAuthState;

function withAuthentication() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return (0, _compose.default)((0, _setDisplayName.default)('AuthenticatedComponent'), withAuthState, withRedirectOnUnauthenticated(options), (0, _setPropTypes.default)({
    auth: _propTypes.default.shape({
      isAuthenticated: _propTypes.default.bool
    })
  }));
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/angieslist-app-platform/lib/common/auth/withAuthentication.js
// module id = 3265
// module chunks = 25